

import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Button, Card, Form } from 'react-bootstrap';
import axios from 'axios';
import "../Pages/Applicant/UploadFiles.css";
import { API_BASE_URL } from '../config';

function ReportProgress({ reportType, appId }) {
  const [acceptedFiles, setAcceptedFiles] = useState([]);
  const [currentReportType, setCurrentReportType] = useState(reportType);
  const [currentAppId, setCurrentAppId] = useState(appId);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (files) => setAcceptedFiles(files),
  });

  useEffect(() => {
    setAcceptedFiles([]); // Clear files when report type changes
    setCurrentReportType(reportType); // Update reportType state
    setCurrentAppId(appId); // Update appId state
  }, [reportType, appId]);

  const files = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('app_ID', currentAppId); // Use currentAppId from state
    formData.append('reportType', currentReportType); // Use currentReportType from state
    
    // Append files under 'file[]'
    acceptedFiles.forEach(file => formData.append('file[]', file));
  
    try {
      const response = await axios.post(`${API_BASE_URL}/ProgressReports.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      console.log('Success:', response.data);
      alert('Files uploaded successfully!');
      
      // Clear fields after successful upload
      setAcceptedFiles([]);
      setCurrentReportType(''); // Clear reportType
      setCurrentAppId(''); // Clear appId
      //setProjectTitle(''); // Clear projectTitle
      
    } catch (error) {
      console.error('Error:', error);
      alert('Error uploading files.');
    }
  };
  
  
  return (
    <div>
      <div className="label-container3">
        <Form.Label>{`Upload ${currentReportType.charAt(0).toUpperCase() + currentReportType.slice(1)} Report`}</Form.Label>
      </div>

      <Card className="dropzone-container">
        <div {...getRootProps({ className: 'dropzone' })}>
          <input {...getInputProps()} />
          <p>Drag & drop file here, or click to select file</p>
          <Button variant="primary">Browse Files</Button>
        </div>
        <aside>
          <h6>Files:</h6>
          <ul>{files}</ul>
        </aside>
      </Card>

      <div>
        <Button variant="success" onClick={handleSubmit} className='submitbutton'>Submit</Button>
      </div>
    </div>
  );
}

export default ReportProgress;
